module.exports = __webpack_public_path__ + "static/media/faq1.0487313f.png";